<template>
  <div class="mt-5">
    <tera-file-select
      :title="'Select records...'"
      :filters="{ library: true }"
      placeholder="Select records to find"
      @change="fileInputEvent($event)"
      style="background: #FFF"
    />
    <div
      style="font-size: 0.875em;font-weight: 400;"
      class="form-text text-muted"
    >
      Select a file to find the relevant papers.
    </div>
    <b-button v-if="file" variant="success" class="mt-3" @click="fileUpload">
      Find
    </b-button>
  </div>
</template>
<script>
import { v4 } from "uuid";
import TeraFileSelect from "@iebh/tera-fy/widgets/tera-file-select.vue";

export default {
  name: "FileUpload",
  components: {
    TeraFileSelect,
  },
  data() {
    return {
      file: null,
      refs: {},
      refList: [],
      endnotefileType: {
        value: { driver: "endnotexml", extention: ".xml" },
        text: "EndNote XML file",
      },
    };
  },
  methods: {
    fileInputEvent(file) {
      this.file = file;
    },
    fileUpload() {
      if (!this.file) return;
      console.log("Loading the file: " + this.file.name);
      //this.readFile(this.file);
      Promise.resolve()
        .then(() => this.file.getRefs())
        .then((refs) =>
          Object.fromEntries(
            // Create a lookup object by ID
            refs.map((ref) => {
              ref.id = ref.id || v4();
              return [ref.id, ref];
            }),
          ),
        )
        .then((refs) => {
          console.log("Extracted refs", { refs });
          if (
            !Object.values(refs).some(
              (ref) =>
                ref.url || ref.accession || ref.accessionNum || ref.medlinePMID,
            )
          )
            return alert(
              "This records does not contain any valid URL or Accession fields from which to extract PubMed IDs",
            );

          const pmids = [];
          Object.keys(refs).forEach((id) => {
            if (refs[id].urls != undefined) {
              const url = refs[id].urls.toString();
              pmids.push(url.split("/").slice(-1)[0]);
            } else if (
              refs[id].accession !== undefined ||
              refs[id].accessionNum !== undefined ||
              refs[id].medlinePMID !== undefined
            ) {
              //If the file not contains urls : <urls/>
              //Try to get <accession-num>
              const pmid =
                refs[id].accession ||
                refs[id].accessionNum ||
                refs[id].medlinePMID;
              pmids.push(pmid);
            }
          });
          this.$emit("getPmids", pmids);
        });
    },
  },
};
</script>
<style></style>
